import React, { useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { errorToast, successToast } from 'configuration/notifications';
import { Auth } from 'store/auth/actions';
import { isAuthenicatedSelector, pendingSelector } from 'store/auth/selectors';
import './style.scss';
import { PasswordResetConfirmForm } from './components/PasswordResetConfirmForm';
import { userApi } from 'helpers/api/user';

export const PasswordResetConfirm = () => {
  const token = new URLSearchParams(window.location.search).get('key') || '';
  const isAuthenticated = useSelector(isAuthenicatedSelector);
  const pending = useSelector(pendingSelector);
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Auth.authErrorAction(null));
    dispatch(Auth.getPriceTypesList());
  }, [dispatch]);

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }
  const handleSubmit = async ({ password, passwordRepeat }) => {
    if (password !== passwordRepeat) {
      errorToast('Пароли не совпадают');
      return;
    }
    const { status } = await userApi.passwordResetConfirm({ token, password });
    if (status == 200) {
      successToast('Пароль успешно изменен');
      history.push('/login');
    }
  };

  return (
    <div className="login-content">
      <PasswordResetConfirmForm pending={pending} onSubmit={handleSubmit} />
    </div>
  );
};
